/**
 * Données de calibration par défaut pour Casque et Inserts.
 * 
 * Pour modifier les valeurs par défaut, éditez simplement les objets ci-dessous.
 * Le champ "date" sera remplacé par la date du jour au moment de l'injection.
 */

export const DEFAULT_HEADPHONES_CALIBRATION = {
  Eoutpout: "Headphones",
  general: "-20",
  vocal: ["1", "1"],
  tonal: [
    "58.2", "40.2", "29.6", "27.3", "26.3", "25.2", "26.6", "26.5", "29.3", "41.5", "46.2",
    "58.2", "40.2", "29.6", "27.3", "26.3", "25.2", "26.6", "26.5", "29.3", "41.5", "46.2",
  ],
};

export const DEFAULT_INSERTS_CALIBRATION = {
  Eoutpout: "Inserts",
  general: "-30",
  vocal: ["1.6", "1.6"],
  tonal: [
    "47.7", "37.5", "30.2", "26.6", "22.5", "24.1", "24.8", "24.6", "26.5", "42.9", "55.5",
    "47.7", "37.5", "30.2", "26.6", "22.5", "24.1", "24.8", "24.6", "26.5", "42.9", "55.5",
  ],
};
